import React from 'react';
import { Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import { handleSidebarHover, handleSidebarHoverAway } from '../../../util/utility.functions';
import './style.css';

const MembersIconActive = require('./MembersIconActive.png');
const MembersIconInactive = require('./MembersIconInactive.png');

function MembersIcon(props) {
  const { active, label } = props;
  const imgSrc = active ? MembersIconActive : MembersIconInactive;
  return (
    <Tooltip title={label}>
      <img
        src={imgSrc}
        alt=""
        height="20"
        width="20"
        onMouseOver={(event) => { handleSidebarHover(event, MembersIconActive); }}
        onFocus={(event) => { handleSidebarHover(event, MembersIconActive); }}
        onMouseLeave={(event) => { handleSidebarHoverAway(event, active, MembersIconInactive); }}
      />
    </Tooltip>
  );
}

MembersIcon.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.bool.isRequired,
};

export default MembersIcon;
